import React, {useEffect, useState} from 'react';

// custom components
import { Text } from '../atoms';
import { List } from '../molecules';

// bootstrap
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';

const ApiTitle = (props) => {

    useEffect(() => {

    }, []);

    const [STATE, SETSTATE] = useState(false)

    return (
        <>
            <Text.Title>{props.smallTitle}</Text.Title>
            <Text.Subtitle>{props.title}</Text.Subtitle>
            {props.callout}
            <Text.Text>{props.subtitle}</Text.Text>

            <Text.Heading>{props.prerequisitesTitle ? props.prerequisitesTitle : 'Prerequisites'}</Text.Heading>
            <List list={props.prerequisites} />
        </>

    );
};

export default ApiTitle;